import React from "react";
import { decode } from "html-entities";
import { Link } from "react-router-dom";
import { getUploadsUrl } from "../../config";
import { useModal } from "../../context/ModalContext";

export default function KeepReading({ prev, next, loading }) {
    const { openModal } = useModal();

    const get = (obj, key) => {
        if (!obj) return null;
        if (obj[key]) return obj[key];
        if (obj.PostData && obj.PostData[key]) return obj.PostData[key];
        if (obj.Post && obj.Post[key]) return obj.Post[key];
        if (obj.data && obj.data[key]) return obj.data[key];
        return null;
    };

    const renderCard = (p) => {
        const slug = get(p, 'slug') || get(p, 'slug');
        const title = get(p, 'title') || '';
        const img = get(p, 'feature_image_url') || get(p, 'feature_image');
        const imgName = get(p, 'feature_image_name') || '';
        const category = get(p, 'category_name') || '';
        const id = get(p, 'id') || title;

        return (
            <Link to={`/blog/${slug}`} className="post-card card" key={id}>
                <div className="thumb">
                    <div className="graphic graphic--fill">
                        <span className="dots"></span>
                        <div className="graphic-center">
                            {img ? (
                                <img loading="lazy" src={getUploadsUrl('posts', img)} alt={imgName || title} />
                            ) : (
                                <span className="initials">{(title||'').split(' ').map(s=>s[0]).slice(0,2).join('').toUpperCase()}</span>
                            )}
                        </div>
                    </div>
                </div>
                <div className="body">
                    {category && category.toLowerCase() !== "uncategorized" && (
                        <span className="kicker">{decode(category)}</span>
                    )}
                    <h3 className="mb-0">{decode(title)}</h3>
                </div>
            </Link>
        );
    };

    if (!prev && !next) {
        if (loading) {
            // show two skeleton cards
            return (
                <section className="keep-reading">
                    <h3>Keep reading</h3>
                    <div className="keep-grid">
                        {[0,1].map(i => (
                            <div className="post-card card skeleton" key={i}>
                                <div className="thumb">
                                    <div className="graphic graphic--fill">
                                        <span className="dots"></span>
                                        <div className="graphic-center">
                                            <span className="initials placeholder-box" />
                                        </div>
                                    </div>
                                </div>
                                <div className="body">
                                    <span className="kicker placeholder-line small" />
                                    <h3 className="mb-0 placeholder-line title" />
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            );
        }
        return null;
    }

    return (
        <section className="keep-reading">
            <h3>Keep reading</h3>
            <div className="keep-grid">
                {prev && renderCard(prev)}
                {next && renderCard(next)}
            </div>
            <div className="cta-band cta-article-mt">
                <h2>Have a process worth building around?</h2>
                <p>Tell us about it — we'll map the shortest path to a custom fit.</p>
                <button className="btn btn-primary" onClick={openModal} type="button">Start a project</button>
            </div>
        </section>
    );
}
